import { render, staticRenderFns } from "./food-details.vue?vue&type=template&id=78b0815e&scoped=true&"
import script from "./food-details.vue?vue&type=script&lang=js&"
export * from "./food-details.vue?vue&type=script&lang=js&"
import style0 from "./food-details.vue?vue&type=style&index=0&id=78b0815e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b0815e",
  null
  
)

export default component.exports